import Button, { ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { maxWidth } from "@mui/system";
import { theme as _theme } from "../../helpers/theme";

export const StyledSecondaryOutlinedButton = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    height: `${_theme.buttonSize.projFormH}`,
    border: `1px solid ${_theme.colors.blue02_hover}`,
    color: `${_theme.colors.blue02_hover}`,
    borderRadius: `${_theme.radius.thirdRadius}`,

    fontWeight: `${_theme.fontWeight.normal}`,
    fontFamily: `${_theme.fonts.interMedium}`,
    textTransform: "none",
    fontSize: "14px",

    // ":disabled": {
    //   backgroundColor: `${_theme.colors.blue03_discabled}`,
    //   color: `${_theme.colors.white}`,
    // },
    "&:hover": {
      backgroundColor: `white`,
      //border: `1px solid ${_theme.colors.blue02_hover}`,
      //color: `${_theme.colors.blue02_hover}`,
    },
  })
);
